import React, { useEffect, useMemo, useState } from 'react'
import axios from 'axios';
import JsPDF from "jspdf";
import "jspdf-autotable";
import moment from 'moment';
import Papa from "papaparse";
import DataTable from 'react-data-table-component';
import { Link, useParams } from 'react-router-dom';
import Swal from 'sweetalert2';
import * as XLSX from "xlsx";
import { usePermissionGuardRedirect } from '../../../hooks/usePermissionGuard';
import SkeletonTicketList from "../../../loaders/SkeletonTicketList";
import {
    processPMCGraduates,
} from "../../../services/GradeSettingService";
import { GetGraduatesStudentsList, GetGraduatesStudentsListFilters, GetProgramDetailCancelToken, UnlinkInatkeToModule } from '../../../services/ProgramService';
import { RenderBrandList } from '../../../utils/CommonGroupingItem';
import { RenderProgrammeStudentStatus } from '../../../utils/CommonStatusItems';
import { TABLE_DATE_FORMAT, TABLE_ROWS_PER_PAGE } from '../../../utils/Constants';
import { handleTableScroll } from '../../../utils/commonFunction';
import PermissionsGate from '../../../utils/permissionGate';
import Str from "../../common/Str";
import Tablefilter from '../../common/Tablefilter';

function GraduatesTable({ data }) {
    const { id } = useParams()
    const [search, setSearch] = useState("");
    const [intake, setIntake] = useState({ arr: [], checkObj: {} });
    const [status, setStatus] = useState({ arr: [], checkObj: {} });
    const [brand, setBrand] = useState({ arr: [], checkObj: {} });
    const [courseType, setCourseType] = useState({ arr: [], checkObj: {} });
    const [loading, setLoading] = useState();
    const [listData, setListData] = useState([])
    const [dropdown, setDropdown] = useState({ status: [], brand: [], intakeGraduated: [] })
    const [school, setSchool] = useState({ arr: [], checkObj: {} })
    const [toggle, setToggle] = useState(false)
    const [totalRows, setTotalRows] = useState(0);
    const [perPage, setPerPage] = useState(10);
    const [page, setPage] = useState(1);
    const [sortkey, setSortKey] = useState("date_calculated");
    const [detail, setDetails] = useState(null)
    const [sortOrder, setSortOrder] = useState("ASC");
    const [tableState, setTableState] = useState({
        page: 1,
        perPage: 10,
        sortKey: "start",
        sortOrder: "DESC"
    })


    useEffect(() => {
        handleTableScroll()
    }, [loading])


    const handlerefresh = () => {
        setToggle(!toggle)
    }
    const handleProcessGraduates = () => {
        if (!detail || !detail.netsuite_product) {
            Swal.fire({
                icon: "error",
                title: "Error",
                text: "Netsuite Product ID is missing. Cannot process graduates.",
            });
            return;
        }
        Swal.fire({
            title: "Processing",
            allowEscapeKey: false,
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading();
            },
        })
        processPMCGraduates({"PMCId" : id, "netsuiteId":detail.netsuite_product}).then((res) => {
            console.log("res.status", res.status);
            console.log("res.data", res.data);
            if (res.status === 200) { 
                let html = "0 new graduates identified";
                let icon = "warning"
                let title = ""
                if (res.data.count && res.data.count > 0) {
                    html = `${res.data.count} new graduate/s identified`;
                    title = "Success"
                    icon = "success"
                }
                if (res.data.qualificationsCheckedNames.length > 0) {
                    html += `<br><div style="max-height:350px; overflow-y:auto;">
                    <table style="width:100%; border-collapse:collapse;">
                        <tr><th>Qualifications Checked</th></tr>                      
                            ${res.data.qualificationsCheckedNames
                            .map(x => `<tr><td style="padding:4px 0;">${x}</td></tr>`)
                            .join('')}
                            
                        </table>
                        </div>
                        `;
                }
                Swal.fire({
                    icon: icon,
                    title: title,
                    html: html,
                    confirmButtonText: "Ok"
                }).then((result) => {
                    setToggle(!toggle)
                })
            } else {
                throw new Error(res);
            }
        }).catch((error) => {
            console.log("error", error);
            Swal.close();
            Swal.fire({
                icon: "error",
                title: "Error",
                text: `${error?.response?.data?.error || error?.response?.data?.message || error?.message || "Something went wrong"}`,
            });
        })
    }
    const handlePageChange = (pageNo) => {
        setPage(pageNo);
    };

    const handlePerRowsChange = (newPerPage, page) => {
        setPerPage(newPerPage);
    };

    const handleSort = (column, sortDirection) => {
        setSortKey(column.selector);
        setSortOrder(sortDirection === "asc" ? "ASC" : "DESC");
    };

    useEffect(
        () => {
            GetProgramDetailCancelToken({ "PMC_ID": id })
                .then((res) => {
                    if (res.status === 200 && res.data && res.data[0]) {
                        const programDetail = res.data[0];
                        setDetails(programDetail);
                        if (!programDetail.netsuite_product) {
                            console.warn('GraduatesTable: netsuite_product is missing from program detail', programDetail);
                        }
                    } else {
                        console.error('GraduatesTable: Invalid response from getPMCDetail', res);
                    }
                }).catch((err) => { 
                    console.error('GraduatesTable: Error fetching program detail', err);
                })
        }, []
    )

    useEffect(
        () => {
            const getFilters = async () => {
                if (!detail || !detail.netsuite_product) {
                    if (detail && !detail.netsuite_product) {
                        console.warn('GraduatesTable: netsuite_product is missing, cannot fetch filters', detail);
                    }
                    return;
                }
                try {
                    const response = await GetGraduatesStudentsListFilters(detail.netsuite_product)
                    if (response.status === 200) {
                        setDropdown({ ...dropdown, intakeGraduated: response.data?.intakeListFilters, status: response.data?.statusFiltersList, brand: response.data?.brandsListFilters })
                    }
                } catch (error) {
                    console.error('GraduatesTable: Error fetching graduates filters', error);
                }
            }
            getFilters()
        }, [detail, toggle]
    )

    useEffect(() => {
        if (!detail || !detail.netsuite_product) {
            setLoading(false);
            if (detail && !detail.netsuite_product) {
                console.warn('GraduatesTable: netsuite_product is missing, cannot fetch graduates list', detail);
            }
            return;
        }
        const cancelTokenSources = [];
        const getData = async () => {
            setLoading(true)
            cancelTokenSources.forEach((source) => {
                source.cancel('New request made');
            });

            const source = axios.CancelToken?.source();
            cancelTokenSources.push(source);
            try {
                const data = {
                    netsuite_product_id: detail.netsuite_product,
                    page: page,
                    limit: perPage,
                    key: sortkey,
                    sort: sortOrder,
                    search: search,
                    intake: intake.arr.length ? intake.arr : [],
                    viaStatus: status.arr.length ? status.arr : [],
                    viaBrand: brand.arr.length ? brand.arr : [],
                    exportStatus: "false"
                }
                const response = await GetGraduatesStudentsList(data)
                if (response.status === 200) {
                    setListData(response.data.data.data);
                    setTotalRows(response.data?.data?.total)
                    setLoading(false)
                }
            } catch (error) {
                if (!axios.isCancel(error)) {
                    console.error('GraduatesTable: Error fetching graduates list', error);
                    setLoading(false)
                }
            }
        };

        getData();

        return () => {
            cancelTokenSources.forEach((source) => {
                source.cancel('Component unmounted');
            });
        };
    }, [intake, status, courseType, sortOrder, page, perPage, sortkey, search, brand, tableState, detail, toggle]);

    usePermissionGuardRedirect(['matpview']);

    const resetFilter = () => {
        setSearch("");
        setIntake({ arr: [], checkObj: {} });
        setBrand({ arr: [], checkObj: {} });
        setStatus({ arr: [], checkObj: {} });
    };

    const exportData = (fileType, fileName) => {
        if (!detail || !detail.netsuite_product) {
            Swal.fire({
                icon: "error",
                title: "Error",
                text: "Netsuite Product ID is missing. Cannot export data.",
            });
            return;
        }
        let data;
        const header = ["Student", "Email", "Student No.", "Status", "Brand", "Intake Graduated", "Date Calculated"];
        Swal.fire({
            title: "File downloading",
            didOpen: function () {
                Swal.showLoading();
            },
        });
        const cData = {
            netsuite_product_id: detail.netsuite_product,
            page: page,
            limit: perPage,
            key: sortkey,
            sort: sortOrder,
            search: search,
            intake: intake.arr.length ? intake.arr : [],
            viaStatus: status.arr.length ? status.arr : [],
            viaBrand: brand.arr.length ? brand.arr : [],
            exportStatus: "true"
        }
        GetGraduatesStudentsList(cData).then(res => {
            data = res.data?.data;
            data = data?.map((row, ind) => ({
                ...row,
                "Student": row?.studentname ? row.studentname : "-",
                "Email": row?.email ? row.email : "-",
                "Student No.": row?.student_crm_id ? row.student_crm_id : "-",
                "Status": row?.status ? RenderProgrammeStudentStatus(row.status).text : "-",
                "Brand": row?.brand_name ? row.brand_name : "-",
                "Intake Graduated": row?.intakes ? row.intakes : "-",
                "Date Calculated": row?.date_calculated ? moment(new Date(row.date_calculated).getTime()).format(TABLE_DATE_FORMAT) : "-"

            }));
            if (fileType === "csv") {
                const csvString = Papa.unparse({ fields: header, data });
                // console.log(csvString);
                const blob = new Blob([csvString], { type: "text/csv;charset=utf-8," });

                const blobURL = window.URL.createObjectURL(blob);

                // Create new tag for download file
                const anchor = document.createElement("a");
                anchor.download = fileName;
                anchor.href = blobURL;
                anchor.dataset.downloadurl = ["text/csv", anchor.download, anchor.href].join(":");
                anchor.click();

                // Remove URL.createObjectURL. The browser should not save the reference to the file.
                setTimeout(() => {
                    // For Firefox it is necessary to delay revoking the ObjectURL
                    URL.revokeObjectURL(blobURL);
                }, 1000);
                Swal.close();
            } else if (fileType === "xlsx") {
                const compatibleData = data.map((row) => {
                    const obj = {};
                    header.map((col, index) => {
                        obj[col] = row[col];
                    });
                    return obj;
                });

                let wb = XLSX.utils.book_new();
                let ws1 = XLSX.utils.json_to_sheet(compatibleData, {
                    header,
                });
                XLSX.utils.book_append_sheet(wb, ws1, "React Table Data");
                XLSX.writeFile(wb, `${fileName}.xlsx`);
                Swal.close();
                // Returning false as downloading of file is already taken care of
                return false;
            }
            if (fileType === "pdf") {
                const compatibleData = data.map((row) => {
                    return [row["Student"], row["Email"], row["Student No."], row["Status"], row["Brand"], row["Intake Graduated"], row["Date Calculated"]];
                });
                const doc = new JsPDF();
                doc.autoTable({
                    head: [header],
                    body: compatibleData,
                    styles: {
                        minCellHeight: 10,
                        color: "white",
                        minCellWidth: 5,
                        halign: "left",
                        fontSize: 8,
                    },
                });
                doc.save(`${fileName}.pdf`);
                Swal.close();
                return false;
            }

        }).catch(error => {
            console.log("error -----> ", error);
        })




    };

    const handleSearchFilter = (e) => {
        const value = e.target.value;
        setSearch(value);
    };

    const myNameFilter = (a, b) => {
        return a.SAQA_Name && a.SAQA_Name.toLowerCase() > b.SAQA_Name && b.SAQA_Name.toLowerCase() ? 1 : -1;
    };
    const myCodeFilter = (a, b) =>
        a.Code.toLowerCase() > b.Code.toLowerCase() ? 1 : -1;
    const myNQFFilter = (a, b) =>
        Number(a.NQF_Level) > Number(b.NQF_Level) ? 1 : -1;

    const columns = useMemo(() => [
        {
            name: "Student",
            selector: "studentname",
            sortable: true,
            wrap: true,
            sortFunction: myNameFilter,
            cell: (row) => (
                <PermissionsGate
                    scopes={["matpedit"]}
                    RenderError={() => <span className="feature-name"> <span className="textLimit100">{row?.studentname ?? "-"}</span></span>}
                >
                    <Link
                        to={`/studentAdministration/students/open/${row?.student_id}/general`}
                        title={row?.studentname ?? "-"}
                        className="as-text-blue curser feature-name"
                    >
                        <span className="textLimit100">{row?.studentname ?? "-"}</span>
                    </Link>
                </PermissionsGate>
            ),
        },
        {
            name: "Email",
            selector: "email",
            // sortFunction: myCodeFilter,
            sortable: true,
            cell: (row, index) => (
                <div className="ticket-id">
                    <span title={row?.email ?? "-"} className="overflow-ellipsis2">
                        {row?.email ?? "-"}
                    </span>
                </div>
            ),
        }, {
            name: "Student No.",
            selector: "student_crm_id",
            // sortFunction: myCodeFilter,

            sortable: true,
            cell: (row, index) => (
                <div className="ticket-id">
                    <span title={row?.student_crm_id ?? "-"} className="overflow-ellipsis2">
                        {row?.student_crm_id ? row.student_crm_id : ""}
                    </span>
                </div>
            ),
        },
        {
            name: "Status",
            selector: "status",
            // sortFunction: myCodeFilter,
            sortable: true,
            cell: (row, index) => (
                <p className="learningMethodText">
                    {row && row.status ? RenderProgrammeStudentStatus(row.status).html : "-"}
                </p>
            ),
        },
        {
            name: "Brand",
            selector: "brand_name",
            // sortFunction: myCodeFilter,
            sortable: true,
            cell: (row, index) => (
                <div className="ticket-id">
                    <span title={row?.brand_name ? RenderBrandList(row.brand_name).html : "-"} >
                        {row?.brand_name ? RenderBrandList(row.brand_name).html : "-"}
                    </span>
                </div>
            ),
        },
        {
            name: "Intake Graduated",
            selector: "intakes",
            // sortFunction: myCodeFilter,
            sortable: true,
            cell: (row, index) => (
                <div className="ticket-id">
                    <span title={row?.intakes ? row.intakes : "-"} className="overflow-ellipsis2">
                        {row?.intakes ? row.intakes : "-"}
                    </span>
                </div>
            ),
        },
        {
            name: "Date Calculated",
            selector: "date_calculated",
            // sortFunction: myCodeFilter,
            sortable: true,
            cell: (row, index) => (
                <span title={row?.date_calculated ? moment(new Date(row.date_calculated).getTime()).format(TABLE_DATE_FORMAT) : "-"} className="overflow-ellipsis2">
                    {row?.date_calculated ? moment(new Date(row.date_calculated).getTime()).format(TABLE_DATE_FORMAT) : "-"}
                </span>
            ),
        },


        {
            name: "Actions",
            selector: "",
            cell: (row) => (
                <div className="assessment-08">
                    <div className="as-buttons">
                        <PermissionsGate
                            scopes={["matpedit"]}
                            RenderError={() => (
                                <button
                                    className="btn btn-primary rounded-circle"
                                    title="Open"
                                    disabled
                                >
                                    <i className="fal fa-folder-open"></i>
                                </button>
                            )}
                        >
                            <Link
                                to={`/studentAdministration/students/open/${row?.student_id}/general`}
                                className="btn btn-primary rounded-circle"
                                title="Open"
                            >
                                <i className="fal fa-folder-open"></i>
                            </Link>
                        </PermissionsGate>
                    </div>
                </div>
            ),
        },
    ]);

    const dataToRender = () => {
        let updatedData = [];
        let allData = data;
        if (search.length) {
            let tempCode = allData.filter((item) => {
                let includes =
                    item.Code &&
                    item.Code.toString().toLowerCase().includes(search.toLowerCase());
                if (includes) {
                    return includes;
                } else return null;
            });
            let tempName = allData.filter((item) => {
                let includes =
                    item.P_SAQA_Name &&
                    item.P_SAQA_Name.toString()
                        .toLowerCase()
                        .includes(search.toLowerCase());
                if (includes) {
                    return includes;
                } else return null;
            });
            let tempLink = allData.filter((item) => {
                let includes =
                    item.P_SAQA_Link &&
                    item.P_SAQA_Link.toString()
                        .toLowerCase()
                        .includes(search.toLowerCase());
                if (includes) {
                    return includes;
                } else return null;
            });
            let tempP_NQF_Level = allData.filter((item) => {
                let includes =
                    item.P_NQF_Level &&
                    item.P_NQF_Level.toString()
                        .toLowerCase()
                        .includes(search.toLowerCase());

                if (includes) {
                    return includes;
                } else return null;
            });
            let tempP_School = allData.filter((item) => {
                let includes =
                    item.P_School &&
                    item.P_School.toString().toLowerCase().includes(search.toLowerCase());
                if (includes) {
                    return includes;
                } else return null;
            });
            let tempP_Quality_Council = allData.filter((item) => {
                let includes =
                    item.P_Quality_Council &&
                    item.P_Quality_Council.toString()
                        .toLowerCase()
                        .includes(search.toLowerCase());
                if (includes) {
                    return includes;
                } else return null;
            });

            let tempdata = [
                ...tempCode,
                ...tempName,
                ...tempLink,
                ...tempP_NQF_Level,
                ...tempP_School,
                ...tempP_Quality_Council,
            ];
            let unique = [...new Set(tempdata)];

            updatedData = unique;
        } else {
            updatedData = allData;
        }

        if (school.arr.length) {
            let tempRole = updatedData;
            let tempSearch = tempRole.filter((item) => {
                const startsWith = school.arr.find(function (user, index) {
                    if (
                        user.toLowerCase() ==
                        (item.P_School ? item.P_School.toLowerCase() : "")
                    )
                        return item;
                });
                if (startsWith) {
                    return startsWith;
                } else return null;
            });

            updatedData = tempSearch;
        }

        if (search.length || school.arr.length) {
            return updatedData;
        } else {
            return data;
        }
    };
    const unlink = (intake_id) => {
        Swal.fire({
            title: "Are you sure?",
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, unlink it!",
        }).then((result) => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: "Please Wait !",
                    allowOutsideClick: false,
                    willOpen: () => {
                        Swal.showLoading();
                    },
                });
                if (!detail || !detail.netsuite_product) {
                    Swal.fire({
                        icon: "error",
                        title: "Error",
                        text: "Netsuite Product ID is missing. Cannot unlink intake.",
                    });
                    return;
                }
                const data = {
                    netsuite_id: detail.netsuite_product,
                    intake_id: intake_id
                }
                UnlinkInatkeToModule(data)
                    .then(res => {
                        Swal.fire({
                            icon: "success",
                            title: "Course Unlinked Successfully",
                        });
                        setToggle(!toggle);
                    }
                    )
                    .catch(err => console.log(err));
            }
        })

    };
    return (
        <div className="my-tickets-info-list Tickets-main-wrap tickets-new-custom">
            <div
                className="custom-table-div filter-search-icon card card-table-custom"
            >
                <div className="search-filter-div">
                    <div className="search-filter-div-left">
                        <div className="system-administration-table table-responsive">
                            <div className="table-responsive-div">
                                <div
                                    id="assessment-table-main_wrapper"
                                    className="dataTables_wrapper no-footer"
                                >
                                    <div
                                        id="assessment-table-main_filter"
                                        className="dataTables_filter"
                                    >
                                        <label>
                                            <input
                                                type="search"
                                                className=""
                                                placeholder="Search"
                                                aria-controls="assessment-table-main"
                                                onChange={handleSearchFilter}
                                                value={search}
                                            />
                                        </label>
                                        <div className="filter-eff filter-data-btn">
                                            <button className="filter-buttons">
                                                <i className="fal fa-filter"></i>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="filter-button-group">
                                <div className="filter-scroll">
                                    <div className={`filter-scroll-inner  filter-custom-new`}>
                                        <Tablefilter
                                            filterName="Status"
                                            optionArr={dropdown.status}
                                            state={status}
                                            setState={setStatus}
                                            renderLabelFunction={RenderProgrammeStudentStatus}
                                        />
                                        <Tablefilter
                                            filterName="Brand"
                                            optionArr={dropdown.brand}
                                            state={brand}
                                            setState={setBrand}
                                            renderLabelFunction={RenderBrandList}
                                            uniqueId='brand'
                                        />
                                        <Tablefilter
                                            filterName="Intake Graduated"
                                            optionArr={dropdown.intakeGraduated}
                                            state={intake}
                                            setState={setIntake}
                                        />
                                    </div>
                                </div>
                                <div className="reset-btn-group">
                                    <div className="button-reset dropdown-comman">
                                        <button
                                            className="btn btn-primary"
                                            onClick={() => resetFilter()}
                                            title="Reset"
                                        >
                                            <i className="fal fa-redo"></i>Reset
                                        </button>
                                    </div>
                                    <div className="files-export-group">
                                        <button
                                            type="button"
                                            className="btn btn-files"
                                            onClick={() => {
                                                exportData("xlsx", "PMC");
                                            }}
                                            title="Export spreadsheet"
                                        >
                                            <i className="fal fa-file-excel icon"></i>
                                        </button>

                                        <button
                                            type="button"
                                            className="btn btn-files"
                                            onClick={() => {
                                                exportData("csv", "PMC");
                                            }}
                                            title="Export CSV"
                                        >
                                            <i className="fal fa-file-csv icon"></i>
                                        </button>

                                        <button
                                            type="button"
                                            className="btn btn-files"
                                            onClick={() => {
                                                exportData("pdf", "PMC");
                                            }}
                                            title="Export PDF"
                                        >
                                            <i className="fal fa-file-pdf icon"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="search-filter-div-right">
                        <div className=" filter-search-bar-blk">
                            <div className="add-ticket-blk button-reset dropdown-comman">
                                <div>
                                    <PermissionsGate scopes={["processgraduates"]} errorProps={{ disabled: true }}>
                                        <button
                                            className="btn btn-primary gb"
                                            title={detail?.netsuite_product 
                                                ? "Determine if any students qualify to graduate looking at their current and past enrolments for this qualification"
                                                : "No PMC Product assigned, cannot process graduates"}
                                            onClick={() => { handleProcessGraduates() }}
                                            disabled={!detail?.netsuite_product}
                                        >
                                            <i className="fal fa-user-graduate"></i>{" "}
                                            {"Process Graduates"}
                                        </button>
                                    </PermissionsGate>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <DataTable
                    data={listData}
                    columns={columns}
                    onSort={handleSort}
                    onChangeRowsPerPage={handlePerRowsChange}
                    onChangePage={handlePageChange}
                    paginationServer={true}
                    pagination={true}
                    progressComponent={<SkeletonTicketList />}
                    sortServer={true}
                    paginationTotalRows={totalRows}
                    progressPending={loading}
                    noDataComponent={Str.noRecord}
                    defaultSortAsc={true}
                    defaultSortField={"date_calculated"}
                    paginationRowsPerPageOptions={TABLE_ROWS_PER_PAGE}
                />
            </div>
        </div>

    )
}

export default GraduatesTable